import { defineMessages } from "react-intl";

export const scope = "pages.DepositPersonalAccountCrypto";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Recibir { ticker }",
  },
  continueButton: {
    id: `${scope}.continueButton`,
    defaultMessage: "CONTINUAR",
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: "CANCELAR",
  },
  sendCryptoButton: {
    id: `${scope}.sendCryptoButton`,
    defaultMessage: "RECIBIR CRIPTO",
  },
  selectNetwork: {
    id: `${scope}.selectNetwork`,
    defaultMessage: "Selecciona una red para recibir { ticker }",
  },
  currencyToReceive: {
    id: `${scope}.currencyToReceive`,
    defaultMessage: "Moneda a recibir",
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: "COPIAR",
  },
});
